import React, { useState, useEffect, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"
import {
  getRewardProgress,
  getUserInfo,
} from "../../core/APIService/apiService"
import ProgressBar from "../../components/ProgressBar/ProgressBar"
import ProgressBarBonus from "../../components/ProgressBar/ProgressBarBonus"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import TMHFormBase from "../../components/TMHForm/TMHFormBase"
import TMHLoader from "../../components/TMHLoader/TMHLoader"
import Separator from "../../components/Separator/Separator"
import SteakIcon from "../../components/SteakIcon/SteakIcon"
import TMHFooter from "../../components/TMHFooter/TMHFooter"
import "./ProfilePage.scss"
import "bootstrap/dist/css/bootstrap.css"
import { ScrollMenu } from "react-horizontal-scrolling-menu"
import useAuth from "../../core/Authentication/useAuth"
import useDrag from "../../core/useDrag/useDrag"
import { ReactComponent as Visibility } from "./images/visibility.svg"
import { ReactComponent as VisibilityOff } from "./images/visibilityOff.svg"
import { ReactComponent as Info } from "./images/info.svg"
import { ReactComponent as RightArrowCustom } from "./images/right-arrow-custom.svg"
import { ReactComponent as Arrow1 } from "./images/arrow-1.svg"
import { ReactComponent as Arrow2 } from "./images/arrow-2.svg"
import { ReactComponent as Arrow3 } from "./images/arrow-3.svg"
import { ReactComponent as RightArrow } from "./images/right-arrow.svg"
import rokuRemoteIcon from "./images/roku-remote-icon.png"
import starIcon from "./images/star-icon.png"
import qrImg from "./images/qr-img-updated.png"
import { Modal } from "react-bootstrap"
import config from "../../config.json"
import validator from "validator"
import { useTitle } from "react-use"
import ReactGA from "react-ga4"
import Popup from "reactjs-popup"

const imgArr = Array.from([...Array(10).keys()], x => x - 8)
const imgArr2 = Array.from([...Array(69).keys()], x => x - 8)
const stateArr = [
  { name: "Alabama", abb: "AL" },
  { name: "Alaska", abb: "AK" },
  { name: "American Samoa", abb: "AS" },
  { name: "Arizona", abb: "AZ" },
  { name: "Arkansas", abb: "AR" },
  { name: "California", abb: "CA" },
  { name: "Colorado", abb: "CO" },
  { name: "Connecticut", abb: "CT" },
  { name: "Delaware", abb: "DE" },
  { name: "District of Columbia", abb: "DC" },
  { name: "Federated States of Micronesia", abb: "FM" },
  { name: "Florida", abb: "FL" },
  { name: "Georgia", abb: "GA" },
  { name: "Guam", abb: "GU" },
  { name: "Hawaii", abb: "HI" },
  { name: "Idaho", abb: "ID" },
  { name: "Illinois", abb: "IL" },
  { name: "Indiana", abb: "IN" },
  { name: "Iowa", abb: "IA" },
  { name: "Kansas", abb: "KS" },
  { name: "Kentucky", abb: "KY" },
  { name: "Louisiana", abb: "LA" },
  { name: "Maine", abb: "ME" },
  { name: "Marshall Islands", abb: "MH" },
  { name: "Maryland", abb: "MD" },
  { name: "Massachusetts", abb: "MA" },
  { name: "Michigan", abb: "MI" },
  { name: "Minnesota", abb: "MN" },
  { name: "Mississippi", abb: "MS" },
  { name: "Missouri", abb: "MO" },
  { name: "Montana", abb: "MT" },
  { name: "Nebraska", abb: "NE" },
  { name: "Nevada", abb: "NV" },
  { name: "New Hampshire", abb: "NH" },
  { name: "New Jersey", abb: "NJ" },
  { name: "New Mexico", abb: "NM" },
  { name: "New York", abb: "NY" },
  { name: "North Carolina", abb: "NC" },
  { name: "North Dakota", abb: "ND" },
  { name: "Northern Mariana Islands", abb: "MP" },
  { name: "Ohio", abb: "OH" },
  { name: "Oklahoma", abb: "OK" },
  { name: "Oregon", abb: "OR" },
  { name: "Palau", abb: "PW" },
  { name: "Pennsylvania", abb: "PA" },
  { name: "Puerto Rico", abb: "PR" },
  { name: "Rhode Island", abb: "RI" },
  { name: "South Carolina", abb: "SC" },
  { name: "South Dakota", abb: "SD" },
  { name: "Tennessee", abb: "TN" },
  { name: "Texas", abb: "TX" },
  { name: "Utah", abb: "UT" },
  { name: "Vermont", abb: "VT" },
  { name: "Virgin Islands", abb: "VI" },
  { name: "Virginia", abb: "VA" },
  { name: "Washington", abb: "WA" },
  { name: "West Virginia", abb: "WV" },
  { name: "Wisconsin", abb: "WI" },
  { name: "Wyoming", abb: "WY" },
]

export default function ProfilePage() {
  useTitle("Profile - The Movie House TV")
  const auth = useAuth()
  const { message } = useParams()
  const navigate = useNavigate()
  const { dragStart, dragStop, dragMove, dragging } = useDrag()
  const apiRef = useRef({})
  const editArrow = require("./images/edit-arrow.png")

  const scrollNext = () => {
    apiRef.current.scrollNext()
  }
  const scrollPre = () => {
    apiRef.current.scrollPrev()
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  const handleDrag =
    ({ scrollContainer }) =>
    ev =>
      dragMove(ev, posDiff => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff
        }
      })

  const onScroll = () => {
    if (apiRef.current) {
      setIsLastItem(apiRef.current.getNextItem() === undefined)
      setIsFirstItem(apiRef.current.getPrevItem() === undefined)
    }
  }
  const handleItemClick = () => {
    if (dragging) {
      return false
    }
    setModalShow(true)
    setShowGiftCardLink2(true)
  }

  const profileSection = useRef(null)
  const executeProfileSectionScroll = () =>
    profileSection.current.scrollIntoView()

  const [
    showCongratulationNextSpinnerPopup,
    setShowCongratulationNextSpinnerPopup,
  ] = useState(false)
  const [useSpinner, setUseSpinner] = useState(false)
  const [rewardCount, setRewardCount] = useState(0)
  const [showProfileSection, setShowProfileSection] = useState(false)
  const [showPasswordSection, setShowPasswordSection] = useState(false)
  const [newRelease, setNewRelease] = useState(false)
  const [showGiftCardLink2, setShowGiftCardLink2] = useState(true)
  const [showGiftCardLink, setShowGiftCardLink] = useState(true)
  const [modalShow, setModalShow] = useState(false)
  const [modalEmailShow, setModalEmailShow] = useState(false)
  const [isLastItem, setIsLastItem] = useState(false)
  const [isFirstItem, setIsFirstItem] = useState(true)
  const [isLoading, setIsLoading] = useState(true)
  const [pinNumber, setPinNumber] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [userStreetAddress, setUserStreetAddress] = useState("")
  const [userCityAddress, setUserCityAddress] = useState("")
  const [userStateAddress, setUserStateAddress] = useState("")
  const [userZipAddress, setUserZipAddress] = useState("")
  const [rateSuccess, setRateSuccess] = useState(false)
  const [progressBarLocked, setProgressBarLocked] = useState(true)
  const [confirmEmailSuccess, setConfirmEmailSuccess] = useState(false)
  const [profileUpdated, setProfileUpdated] = useState(false)
  const [rmrBonus, setRmrBonus] = useState(false)
  const [extBonus, setExtBonus] = useState(false)
  const [userCodes, setUserCodes] = useState([])
  const [password, setPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [progressPercent, setProgressPercent] = useState(0)
  const [profileError, setProfileError] = useState("")
  const [profileSuccess, setProfileSuccess] = useState("")
  const [pwError, setPWError] = useState("")
  const [pwSuccess, setPWSuccess] = useState("")
  const [showInsModal1, setShowInsModal1] = useState(false)
  const [showInsModal2, setShowInsModal2] = useState(false)
  const [showInstallRokuModalDesktop, setShowInstallRokuModalDesktop] =
    useState(false)
  const [showInstallRokuModalAndroid, setShowInstallRokuModalAndroid] =
    useState(false)
  const [visible, setVisible] = useState({
    password: false,
    newPassword: false,
    confirmPassword: false,
  })

  const isShowBoostBonusesAvailable =
    !confirmEmailSuccess ||
    !profileSuccess ||
    !rateSuccess ||
    !extBonus ||
    !rmrBonus
  const isShowCompletedBonuses =
    confirmEmailSuccess || profileSuccess || rateSuccess || extBonus || rmrBonus

  const listUserCodes = userCodes.map((userCode, index) => {
    let dateTemp = new Date(Date.parse(userCode.claimed_at))
    let dateStr = dateTemp.toDateString()
    return (
      <li key={index}>
        <p className="gift-date">{dateStr}</p>
        <p className="gift-value">
          {userCode.partner_name} Gift Card ({userCode.code})
        </p>
      </li>
    )
  })

  const listStateOptions = stateArr.map(({ name, abb }) => {
    return (
      <option key={abb} value={abb}>
        {name}
      </option>
    )
  })

  const onProfileButtonCompleteClicked = () => {
    if (!profileUpdated) {
      setShowProfileSection(true)
      executeProfileSectionScroll()
    }
  }

  useEffect(() => {
    async function initData() {
      if (auth.isLogged()) {
        const data = await getUserInfo(auth.user.token)
        if (!data) return
        if (data.status !== 200) {
          auth.logout()
          navigate("/login")
          return
        }

        if (
          message === "congratulation-next-spinner" &&
          data.is_spin2 === true
        ) {
          setShowCongratulationNextSpinnerPopup(true)
        } else if (data.is_spin2 === true && data.use_spinner === true) {
          navigate("/request-coupon")
          return
        }

        ReactGA.send("pageview")
        if (!data.pin_verified) {
          navigate("/verification")
          return
        }

        var cid = localStorage.getItem("postBack-cid")
        if (cid) {
          var iframe = document.createElement("iframe")
          iframe.title = "hidden frame"
          iframe.hidden = true
          iframe.name = "hiddenFrame"
          document.body.appendChild(iframe)

          const postBackLink =
            "https://relywandalimbilton.com/postback?cid=" + cid
          console.log("postBackLink::", postBackLink)
          window.open(postBackLink, "hiddenFrame")
          localStorage.removeItem("postBack-cid")
        }

        updateProfileData(data)
        setProgressPercent(
          parseFloat(await getRewardProgress(String(auth.user?.user_id)))
        )

        setIsLoading(false)
      } else {
        navigate("/login")
      }
    }

    initData()

    const interval = setInterval(async () => {
      if (auth.user?.user_id !== undefined) {
        setProgressPercent(
          parseFloat(await getRewardProgress(auth.user?.user_id))
        )
      }
    }, 30 * 1000)
    return () => clearInterval(interval)
  }, [auth, message, navigate, useSpinner])

  function showModal(ins1 = false, ins2 = false) {
    setShowInsModal1(ins1)
    setShowInsModal2(ins2)
  }

  function updateProfileData(data = null) {
    setPinNumber(data?.pin)
    setFirstName(data?.first_name ?? "")
    setLastName(data?.last_name ?? "")
    setUserStreetAddress(data?.user_street_address ?? "")
    setUserCityAddress(data?.user_city_address ?? "")
    setUserZipAddress(data?.user_zip_address ?? "")
    setUserStateAddress(data?.user_state_address ?? "")
    setEmail(data?.email)
    setUserCodes(data?.codes)
    setRateSuccess(data?.confirm_rating)
    setProgressBarLocked(data?.progress_locked)
    setProfileUpdated(data?.profile_updated)
    setRmrBonus(data?.install_rmr)
    setExtBonus(data?.install_ext)
    setConfirmEmailSuccess(data?.confirm_email_updated)
    setUseSpinner(data?.use_spinner)
    setRewardCount(data?.reward_count ?? 0)
  }

  function sendConfirmEmail() {
    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    myHeaders.append("Access-Token", auth.user?.token)
    myHeaders.append("Cache-Control", "no-cache")

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({}),
    }

    fetch(config.baseUrl + "send_confirm_email", requestOptions)
      .then(response => {
        return new Promise(resolve =>
          response.json().then(json =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        )
      })
      .then(
        result => {
          if (result.ok) {
            alert(result.json.message)
            setModalEmailShow(false)
          } else {
            alert(result.json.message)
          }
        },
        error => {
          alert("An error occurred, please try again!")
        }
      )
  }

  function handlePWSubmit(event) {
    event.preventDefault()
    resetMessage()

    if (password === "" || newPassword === "" || confirmPassword === "") {
      setPWError("Password is required!")
      return
    } else if (newPassword !== confirmPassword) {
      setPWError("Password does not match!")
      return
    }

    setIsLoading(true)
    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    myHeaders.append("Access-Token", auth.user?.token)
    myHeaders.append("Cache-Control", "no-cache")

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        current_password: password,
        password: newPassword,
        confirm_password: confirmPassword,
      }),
    }

    fetch(config.baseUrl + "update_user_password", requestOptions)
      .then(response => response.json())
      .then(
        result => {
          if (result.token) {
            let user = { ...auth.user }
            user.token = result.token
            auth.login(user)
            setPWSuccess(result.message)
            setPWError("")
          } else {
            setPWError(result.message)
            setPWSuccess("")
          }

          setIsLoading(false)
        },
        error => {
          console.log(error)
          setPWError(error.toString())
          setIsLoading(false)
        }
      )
  }

  function resetMessage(
    profileErrorMsg = "",
    profileSuccessMsg = "",
    pwErrorMsg = "",
    pwSuccessMsg = ""
  ) {
    setProfileError(profileErrorMsg)
    setProfileSuccess(profileSuccessMsg)
    setPWError(pwErrorMsg)
    setPWSuccess(pwSuccessMsg)
  }

  async function handleProfileSubmit(event) {
    resetMessage()
    event.preventDefault()
    if (email === "") {
      setProfileError("Email is required!")
      return
    }

    if (firstName === "") {
      setProfileError("First name is required!")
      return
    }

    if (lastName === "") {
      setProfileError("Last name is required!")
      return
    }

    if (userStreetAddress === "") {
      setProfileError("Street address is required!")
      return
    }

    if (userCityAddress === "") {
      setProfileError("City address is required!")
      return
    }

    if (userStateAddress === "") {
      setProfileError("State is required!")
      return
    }

    if (userZipAddress === "") {
      setProfileError("Zip is required!")
      return
    }

    if (!validator.isEmail(email)) {
      setProfileError("Email Field is Invalid")
      return
    }

    if (!validator.isNumeric(userZipAddress) || userZipAddress.length !== 5) {
      setProfileError("Zip Field is Invalid")
      return
    }

    if (userCityAddress.length > 17) {
      setProfileError("City Field is Invalid")
      return
    }

    setIsLoading(true)

    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    myHeaders.append("Access-Token", auth.user?.token)
    myHeaders.append("Cache-Control", "no-cache")

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({
        email: email,
        first_name: firstName,
        last_name: lastName,
        user_street_address: userStreetAddress,
        user_city_address: userCityAddress,
        user_zip_address: userZipAddress,
        user_state_address: userStateAddress,
      }),
    }

    fetch(config.baseUrl + "update_user_profile", requestOptions)
      .then(response => {
        return new Promise(resolve =>
          response.json().then(json =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        )
      })
      .then(
        async result => {
          let json = result.json
          if (result.ok) {
            let user = { ...auth.user }
            user.token = json.token
            user.username = json.username
            auth.login(user)
            setProfileUpdated(true)
            setProgressPercent(
              parseFloat(await getRewardProgress(auth.user?.user_id))
            )
            setProfileSuccess(json.message)
            setProfileError("")
          } else {
            setProfileError(json.message)
            setProfileSuccess("")
          }
          setIsLoading(false)
        },
        error => {
          console.error(error)
          setProfileError(error.toString())
          setIsLoading(false)
        }
      )
  }

  return (
    <>
      <TMHBanner
        classOption="only-gradient"
        isAuth
        styleId={2}
        useSpinner={useSpinner}
        navClass="profile-header"
      >
        {!newRelease ? (
          <div className="profile-wrapper">
            <div className="profile-nav">
              <div
                className="bar-wrapper"
                style={{ opacity: progressBarLocked ? 0 : 1 }}
              >
                <div className="bar-text">
                  <Arrow1 className="arrow-1" />
                  Your live progress to a free new release movie
                  <Arrow2 className="arrow-2" />
                </div>
                <ProgressBar percent={progressPercent} />
              </div>
              <div
                className={
                  progressPercent === 100 ? "get-movie" : "get-movie-disabled"
                }
              >
                <div
                  className="get-movie-text"
                  style={{ opacity: progressBarLocked ? 1 : 1 }}
                >
                  Hit 100%? Claim here
                  <Arrow3 className="arrow-3" />
                </div>
                <button
                  onClick={() => {
                    if (progressPercent === 100)
                      window.open("/tmh/#/request-coupon", "_blank")
                  }}
                  className="get-movie-btn"
                >
                  Get Your Free Movie
                </button>
              </div>

              <div className="nav-detail">
                <span>
                  <Info
                    fill="white"
                    width={24}
                    height={24}
                    style={{ marginRight: "8px" }}
                  />
                </span>
                My details
              </div>
              <button
                onClick={() => showModal(!showInsModal1, false)}
                className="nav-inst"
              >
                Instructions
                <span>
                  <RightArrowCustom
                    fill="white"
                    width={14.09}
                    height={13.7}
                    style={
                      showInsModal1
                        ? { marginLeft: "14px", transform: "rotate(90deg)" }
                        : { marginLeft: "14px" }
                    }
                  />
                </span>
                {showInsModal1 && (
                  <div className="nav-modal">
                    <div className="modal-container">
                      <a href="/tmh/#/install-direct" target="_blank">
                        Install direct on my Roku Device
                      </a>
                      <a href="/tmh/#/visit-roku-website" target="_blank">
                        Use my account on Roku.com
                      </a>
                    </div>
                  </div>
                )}
              </button>
            </div>

            <div className="profile-page">
              <div className="profile-setting">
                <div
                  className={
                    progressPercent === 100
                      ? "block-get-movie"
                      : "block-get-movie-disabled"
                  }
                />
                <div className="title">Congratulations</div>
                <Separator style={{ marginTop: "2px", marginBottom: "5px" }} />
                <div className="welcome-area">
                  <p>
                    You're connected to The Movie House app. Some bonus progress
                    is added just for syncing. More can be added by completing
                    the below quick tasks and, importantly watching standard
                    Movies and TV on The Movie import ProgressBar from
                    './../../components/ProgressBar/ProgressBar'; House app.
                    Continue to hit 100% to unlock Free Premium New Release
                    Movies of your choice!
                  </p>
                  <div className="title">Spin Streak Progress</div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: 30,
                    }}
                  >
                    {[...Array(5)].map((_, i) => (
                      <SteakIcon
                        isDisabled={i >= rewardCount}
                        isGif={i > 3}
                        key={i}
                      />
                    ))}
                  </div>

                  {isShowBoostBonusesAvailable && (
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        flexDirection: "column",
                      }}
                    >
                      <div className="title">Boost Bonuses Available</div>
                      {!extBonus && (
                        <div
                          onClick={() => {
                            window.open(
                              "https://mymovieremote.com/#/extension",
                              "_blank"
                            )
                          }}
                        >
                          <ProgressBarBonus
                            styleBonus="ext-remote-app"
                            isCompleted={false}
                          />
                        </div>
                      )}
                      {!rmrBonus && (
                        <div
                          onClick={() => {
                            window.open("https://mymovieremote.com/", "_blank")
                          }}
                        >
                          <ProgressBarBonus
                            styleBonus="roku-remote-app"
                            isCompleted={false}
                          />
                        </div>
                      )}
                      {!confirmEmailSuccess && (
                        <div
                          onClick={() => {
                            setModalEmailShow(true)
                          }}
                        >
                          <ProgressBarBonus
                            isCompleted={false}
                            styleBonus="email"
                          />
                        </div>
                      )}
                      {!profileUpdated && (
                        <div onClick={() => onProfileButtonCompleteClicked()}>
                          <ProgressBarBonus
                            isCompleted={false}
                            styleBonus="profile"
                          />
                        </div>
                      )}
                      {!rateSuccess && (
                        <div
                          onClick={() => {
                            navigate("/rate-movie-house")
                          }}
                        >
                          <ProgressBarBonus
                            styleBonus="rate"
                            isCompleted={false}
                          />
                        </div>
                      )}
                    </div>
                  )}

                  <div style={{ height: 30 }}></div>

                  {isShowCompletedBonuses && (
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        flexDirection: "column",
                      }}
                    >
                      <div className="title">Completed Bonuses</div>
                      {extBonus && (
                        <ProgressBarBonus
                          styleBonus="ext-remote-app"
                          isCompleted={true}
                        />
                      )}
                      {rmrBonus && (
                        <ProgressBarBonus
                          styleBonus="roku-remote-app"
                          isCompleted={true}
                        />
                      )}
                      {confirmEmailSuccess && (
                        <ProgressBarBonus
                          isCompleted={true}
                          styleBonus="email"
                        />
                      )}
                      {profileUpdated && (
                        <div onClick={() => onProfileButtonCompleteClicked()}>
                          <ProgressBarBonus
                            isCompleted={true}
                            styleBonus="profile"
                          />
                        </div>
                      )}
                      {rateSuccess && (
                        <ProgressBarBonus
                          styleBonus="rate"
                          isCompleted={true}
                        />
                      )}
                    </div>
                  )}

                  <div style={{ height: 50 }}></div>

                  <p>
                    At 100%, 1000s of Premium New Release Movies &#38; TV are
                    available with your gift card.
                  </p>

                  <div className="library-film">
                    <ScrollMenu
                      onMouseDown={() => dragStart}
                      onMouseUp={() => dragStop}
                      onMouseMove={handleDrag}
                      onScroll={onScroll}
                      apiRef={apiRef}
                    >
                      {imgArr.map(id => (
                        <li
                          itemID={String(id)}
                          key={id}
                          onClick={() => handleItemClick()}
                        >
                          <div
                            role="button"
                            style={{
                              display: "inline-block",
                              margin: "0 10px",
                              userSelect: "none",
                            }}
                            tabIndex={0}
                            className="film-wrapper"
                          >
                            <img
                              draggable={false}
                              src={
                                "https://themoviehouse.tv/categories/films/film-" +
                                String(id) +
                                ".png"
                              }
                              alt={"film - " + String(id)}
                              className="film-item"
                            />
                          </div>
                        </li>
                      ))}
                    </ScrollMenu>
                    <div className="arrow-control">
                      <RightArrow
                        style={{ opacity: isLastItem ? "0" : "1" }}
                        className="right-arrow"
                        onClick={scrollNext}
                      />
                      <RightArrow
                        style={{ opacity: isFirstItem ? "0" : "1" }}
                        className="left-arrow"
                        onClick={scrollPre}
                      />
                    </div>
                    <button
                      onClick={() => setNewRelease(true)}
                      className="view-all"
                    >
                      View All
                    </button>
                  </div>
                  {showGiftCardLink && (
                    <div className="gift-card-link">
                      <div className="bg" />
                      <a
                        href="https://www.fandango.com/fandango-gift-cards"
                        rel="noreferrer"
                        target="_blank"
                      >
                        Don’t want to wait?{" "}
                        <b>buy a fandango gift cards here now</b>
                      </a>
                      <button
                        className="close-button-gift"
                        onClick={() => setShowGiftCardLink(false)}
                      />
                    </div>
                  )}

                  <p>
                    Do you have any questions or need any help? please{" "}
                    <a href="/tmh/#/contact-us" target="_blank">
                      contact us here
                    </a>
                  </p>
                </div>

                <div
                  className="profile-inst"
                  onClick={() => showModal(false, !showInsModal2)}
                >
                  <Separator
                    style={{ marginTop: "0px", marginBottom: "20px" }}
                  />
                  <button className="inst-btn">
                    View Roku Install Instructions
                    <span>
                      <RightArrowCustom
                        fill="white"
                        width={14.09}
                        height={13.7}
                        style={
                          showInsModal2 ? { transform: "rotate(90deg)" } : {}
                        }
                      />
                    </span>
                    {showInsModal2 && (
                      <div className="ins-modal">
                        <div className="ins-modal-container">
                          <a href="/tmh/#/install-direct" target="_blank">
                            Install direct on my Roku Device
                          </a>
                          <a href="/tmh/#/visit-roku-website" target="_blank">
                            Use my account on Roku.com
                          </a>
                        </div>
                      </div>
                    )}
                  </button>
                  <Separator
                    style={{ marginTop: "25px", marginBottom: "20px" }}
                  />
                </div>
                <div className="title-block" ref={profileSection}>
                  <div className="title">Profile Settings </div>
                  {!showProfileSection && (
                    <button
                      onClick={() => setShowProfileSection(!showProfileSection)}
                      className="edit-toggle-button"
                    >
                      Edit <img src={editArrow} alt="edit" />
                    </button>
                  )}
                </div>
                {showProfileSection && (
                  <TMHFormBase
                    onClick={() => showModal(false, false)}
                    onSubmit={handleProfileSubmit}
                    method="POST"
                  >
                    <input
                      className="tmhform-input"
                      placeholder="Member Pin"
                      value={pinNumber}
                      disabled={true}
                    />
                    <div className="input-haft">
                      <input
                        className="tmhform-input"
                        placeholder="First Name"
                        value={firstName}
                        onChange={({ target }) => setFirstName(target.value)}
                      />
                      <input
                        className="tmhform-input"
                        placeholder="Last Name"
                        value={lastName}
                        onChange={({ target }) => setLastName(target.value)}
                      />
                    </div>

                    <input
                      className="tmhform-input"
                      placeholder="Email*"
                      value={email}
                      onChange={({ target }) => setEmail(target.value)}
                    />
                    <p className="tmhform-text">Address</p>
                    <input
                      className="tmhform-input"
                      placeholder="Street address"
                      value={userStreetAddress}
                      onChange={({ target }) =>
                        setUserStreetAddress(target.value)
                      }
                    />
                    <div className="input-haft">
                      <input
                        className="tmhform-input"
                        placeholder="City"
                        value={userCityAddress}
                        onChange={({ target }) =>
                          setUserCityAddress(target.value)
                        }
                      />
                      <select
                        value={userStateAddress}
                        onChange={({ target }) =>
                          setUserStateAddress(target.value)
                        }
                        style={
                          userStateAddress === ""
                            ? { color: "#ffffff66" }
                            : { color: "#ffffff" }
                        }
                        className="tmhform-input"
                      >
                        <option value="" disabled hidden>
                          State
                        </option>
                        {listStateOptions}
                      </select>
                    </div>
                    <div className="input-haft">
                      <input
                        className="tmhform-input"
                        value="USA (only)"
                        disabled={true}
                      />
                      <input
                        className="tmhform-input"
                        placeholder="Zip"
                        value={userZipAddress}
                        onChange={({ target }) =>
                          setUserZipAddress(target.value)
                        }
                      />
                    </div>

                    <p className="form-desc text-manrope-medium-14 ">
                      Ensure your details are correct as this is where we will
                      send your code for your new release movie access. Filling
                      out all fields ensures you receive your one time 25% bonus
                      progress.
                    </p>
                    <input
                      className="submit-btn"
                      type="submit"
                      value="Update"
                    />

                    <div style={{ color: "white" }}>{profileError}</div>
                    <div style={{ color: "green" }}>{profileSuccess}</div>
                  </TMHFormBase>
                )}
              </div>
              <div className="Separator-hoz">
                <Separator />
              </div>
              <div className="change-password">
                <div className="title-block">
                  <div className="title">Change Password</div>
                  {!showPasswordSection && (
                    <button
                      onClick={() =>
                        setShowPasswordSection(!showPasswordSection)
                      }
                      className="edit-toggle-button"
                    >
                      Edit <img src={editArrow} alt="edit" />
                    </button>
                  )}
                </div>
                {showPasswordSection && (
                  <TMHFormBase onSubmit={handlePWSubmit} method="POST">
                    <div style={{ color: "red" }}>{pwError}</div>
                    <div style={{ color: "green" }}>{pwSuccess}</div>
                    <div className="input-wrapper">
                      <input
                        className="tmhform-input"
                        placeholder="Current Password"
                        type={visible.password ? "text" : "password"}
                        value={password}
                        onChange={({ target }) => setPassword(target.value)}
                      />
                      <div
                        onClick={() =>
                          setVisible(prevState => {
                            return { ...prevState, password: !visible.password }
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {visible?.password ? <VisibilityOff /> : <Visibility />}
                      </div>
                    </div>

                    <div className="input-wrapper">
                      <input
                        className="tmhform-input"
                        placeholder="New Password"
                        type={visible.newPassword ? "text" : "password"}
                        value={newPassword}
                        onChange={({ target }) => setNewPassword(target.value)}
                      />
                      <div
                        onClick={() =>
                          setVisible(prevState => {
                            return {
                              ...prevState,
                              newPassword: !visible.newPassword,
                            }
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {visible?.newPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </div>
                    </div>

                    <div className="input-wrapper">
                      <input
                        className="tmhform-input"
                        placeholder="Confirm Password"
                        type={visible.confirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={({ target }) =>
                          setConfirmPassword(target.value)
                        }
                      />

                      <div
                        onClick={() =>
                          setVisible(prevState => {
                            return {
                              ...prevState,
                              confirmPassword: !visible.confirmPassword,
                            }
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {visible?.confirmPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </div>
                    </div>
                    <input
                      className="submit-btn"
                      type="submit"
                      value="Update"
                    />
                  </TMHFormBase>
                )}
                <div className="gift-code">
                  <div className="title">Your Gift Card Code History</div>
                  {listUserCodes}
                </div>
              </div>
            </div>

            <TMHFooter />
          </div>
        ) : (
          <div className="new-releases-wrapper">
            <div
              className="new-releases-nav"
              onClick={() => setNewRelease(false)}
            >
              <RightArrow className="left-arrow" /> back to dashboard
            </div>
            <div className="new-releases-content">
              {imgArr2.map(id => (
                <li key={id}>
                  <img
                    src={
                      "https://themoviehouse.tv/categories/films/film-" +
                      String(id) +
                      ".png"
                    }
                    alt={"film - " + String(id)}
                    onClick={() => {
                      setModalShow(true)
                      setShowGiftCardLink2(true)
                    }}
                  />
                </li>
              ))}
            </div>
            <div className="note">- &#38; 1000’s more -</div>
            <TMHFooter />
          </div>
        )}

        <Popup
          modal
          open={showCongratulationNextSpinnerPopup}
          overlayStyle={{
            backgroundColor: "#000000B2",
          }}
        >
          <div className="modal-congratulation-next-spinner">
            <div className="bg">
              <div className="content">
                <div className="popup-title">
                  Congratulations for claiming your first spin reward!
                </div>
                <div className="popup-description">
                  Your spinner has been reset and is ready to go again.
                </div>

                <button
                  className="popup-proceed-button"
                  onClick={() => {
                    setShowCongratulationNextSpinnerPopup(false)
                  }}
                >
                  Spin on my Roku Now
                </button>

                <button
                  className="popup-close-button"
                  onClick={() => setShowCongratulationNextSpinnerPopup(false)}
                />
              </div>
            </div>
          </div>
        </Popup>
      </TMHBanner>
      {isLoading && <TMHLoader />}

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="small"
        centered
      >
        <Modal.Body className="modal-body-dark">
          <div className="close-button" onClick={() => setModalShow(false)} />
          <p>
            Keep watching The Movie House content on your Roku and once your
            progress bar hits <b>100% claim your Free New Release Movie.</b>
          </p>
        </Modal.Body>
        <Modal.Footer className="modal-footer-dark">
          {showGiftCardLink2 && (
            <div className="gift-card-link">
              <div className="bg" />
              <a
                href="https://www.fandango.com/fandango-gift-cards"
                rel="noreferrer"
                target="_blank"
              >
                Don’t want to wait? <b>buy a fandango gift cards here now</b>
              </a>
              <button
                className="close-button-gift"
                onClick={() => setShowGiftCardLink2(false)}
              />
            </div>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={modalEmailShow}
        onHide={() => setModalEmailShow(false)}
        size="lg"
        centered
      >
        <Modal.Body className="modal-body-dark-2">
          <div
            className="close-button"
            onClick={() => setModalEmailShow(false)}
          />
          <p>
            A confirmation email will be sent to
            <br />
            {email}. <br />
            Please open the email and click “confirm” to verify and your 25%
            bonus will be added to your progress bar. <br />
          </p>
          <p style={{ textDecoration: "line" }}>
            **<b>please check your spam folder if you do not see it</b>**
          </p>
          <div className="send-email-gr">
            <button onClick={() => sendConfirmEmail()} className="send-button">
              Send Email
            </button>
            <button
              onClick={async () => {
                setModalEmailShow(false)
                sleep(200).then(() => {
                  setShowProfileSection(true)
                  executeProfileSectionScroll()
                })
              }}
              className="modal-note"
            >
              Edit my email
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showInstallRokuModalAndroid}
        onHide={() => setShowInstallRokuModalAndroid(false)}
        size="lg"
        centered
      >
        <Modal.Body className="modal-body-dark-3">
          <div
            className="close-button"
            onClick={() => setShowInstallRokuModalAndroid(false)}
          />
          <img
            className="roku-remote-icon"
            alt="roku-remote-icon"
            src={rokuRemoteIcon}
          />
          <div className="remote-app-text">
            Simple{" "}
            <b>
              Roku
              <br />
              Remote +
            </b>
          </div>
          <div className="block-text-1">
            <p>
              Download and install the Roku Remote + for your Android device to
              control any app on your Roku device just as easily as your Roku
              remote.
            </p>
          </div>
          <div className="block-text-2">
            <p>1. Install via google play</p>
            <p>
              2. Give us a great rating{" "}
              <img className="star-icon" src={starIcon} alt="star"></img>
              <img className="star-icon" src={starIcon} alt="star"></img>
              <img className="star-icon" src={starIcon} alt="star"></img>
              <img className="star-icon" src={starIcon} alt="star"></img>
              <img className="star-icon" src={starIcon} alt="star"></img>
            </p>
            <p>3. We'll verify and add your 25%</p>
          </div>

          <a
            href="https://play.google.com/store/apps/details?id=com.rokuremote"
            target="_blank"
            rel="noreferrer"
          >
            <button className="send-button">INSTALL ON GOOGLE PLAY NOW</button>
          </a>
        </Modal.Body>
      </Modal>

      <Modal
        show={showInstallRokuModalDesktop}
        onHide={() => setShowInstallRokuModalDesktop(false)}
        size="lg"
        centered
      >
        <Modal.Body className="modal-body-dark-3">
          <div
            className="close-button"
            onClick={() => setShowInstallRokuModalDesktop(false)}
          />
          <img
            className="roku-remote-icon"
            alt="roku-remote-icon"
            src={rokuRemoteIcon}
          />
          <div className="remote-app-text">
            Simple{" "}
            <b>
              Roku
              <br />
              Remote +
            </b>
          </div>
          <div className="block-text-1">
            <p>
              Available on <b>Android devices only.</b> Download on your device
              now by scanning the below code.
            </p>
          </div>
          <img className="qr-img" alt="qr" src={qrImg} />
        </Modal.Body>
      </Modal>
    </>
  )
}
